import { IAppState } from 'models/store.model'
import { getStripePurchaseCommonEventParams } from 'modules/purchase/helpers/getStripePurchaseCommonEventParams'

export const getStripePurchaseSuccessEventParams = (state: IAppState) => {
  const {
    stripePriceId,
    trialPeriodPrice,
    uuid,
    periodName,
    periodQuantity,
    currency,
    screenName,
  } = getStripePurchaseCommonEventParams(state)

  return {
    productId: stripePriceId,
    trialPrice: trialPeriodPrice,
    uuid,
    periodName,
    periodQuantity,
    currency,
    screenName,
  }
}
